import React from "react";

/**
 * Energy divider — a thin cinematic strip placed between sections.
 * Renders a horizontal lightning sweep + drifting energy particles + a
 * glowing focal point that hints at a "ball passing through" the divider.
 *
 * Props:
 *  - flip: mirror the lightning direction
 *  - color: focal-point color
 */
const EnergyDivider = ({ flip = false, color = "#FF3DCB" }) => {
  return (
    <div
      aria-hidden
      className="relative mx-auto my-0 flex h-24 w-full max-w-[1400px] items-center overflow-hidden px-5 md:px-10"
    >
      {/* Background line */}
      <div className="relative h-px w-full">
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(90deg, transparent 0%, rgba(255,45,92,0.4) 18%, rgba(255,61,203,0.55) 38%, rgba(155,77,255,0.55) 58%, rgba(61,191,255,0.4) 82%, transparent 100%)",
          }}
        />
        {/* Sweeping light */}
        <div
          className="absolute -top-px h-[2px] w-32"
          style={{
            background: `linear-gradient(90deg, transparent, ${color}, transparent)`,
            filter: `drop-shadow(0 0 10px ${color}) drop-shadow(0 0 24px ${color})`,
            animation: "eu-divider-sweep 6s ease-in-out infinite",
            animationDirection: flip ? "reverse" : "normal",
          }}
        />
      </div>

      {/* Drifting football-energy particles above the line */}
      {[...Array(7)].map((_, i) => (
        <span
          key={i}
          className="absolute h-1 w-1 rounded-full"
          style={{
            left: `${10 + i * 13}%`,
            top: `${28 + (i % 3) * 14}%`,
            background: i % 2 === 0 ? "#FF3DCB" : "#3DBFFF",
            boxShadow: `0 0 12px ${i % 2 === 0 ? "#FF3DCB" : "#3DBFFF"}, 0 0 4px #fff`,
            animation: `eu-particle-float ${4 + (i % 4)}s ease-in-out infinite`,
            animationDelay: `${-i * 0.6}s`,
            opacity: 0.7,
          }}
        />
      ))}
    </div>
  );
};

export default EnergyDivider;
